import Enum from "../../../../../../enums/Enum";

const CurrentPastEnum = new Enum({
    CURRENT: {name: "Current"},
    PAST: {name: "Past"}
});

export default CurrentPastEnum;